import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types";
import type { DetailActionStrict, ActionVariant } from "../../types/detail-action";
import { ACTION_ICONS, ACTION_VARIANTS, ROLE_COMBINATIONS } from "../../types/action-properties";

export function createMakeContactAction<T extends BaseEntity>(
  options: {
    label?: string;
    icon?: string;
    variant?: ActionVariant;
    allowedRoles?: string[];
    bulkable?: boolean;
  } = {}
): DetailActionStrict<T> {
  return {
    id: "make-contact",
    label: options.label ?? "Make Contact",
    icon: options.icon ?? ACTION_ICONS.USER,
    variant: options.variant ?? ACTION_VARIANTS.OUTLINE,
    action: "makeContact",
    allowedRoles: options.allowedRoles ?? [...ROLE_COMBINATIONS.EMPLOYEE_AND_ADMIN],
    bulkable: options.bulkable ?? true,
  };
}

export function createLinkContactAction<T extends BaseEntity>(
  options: {
    label?: string;
    icon?: string;
    variant?: ActionVariant;
    allowedRoles?: string[];
  } = {}
): DetailActionStrict<T> {
  return {
    id: "link-contact",
    label: options.label ?? "Link Contact",
    icon: options.icon ?? ACTION_ICONS.COPY_LINK,
    variant: options.variant ?? ACTION_VARIANTS.OUTLINE,
    action: "linkContact",
    allowedRoles: options.allowedRoles ?? [...ROLE_COMBINATIONS.EMPLOYEE_AND_ADMIN],
  };
}

export function createLogDealAction<T extends BaseEntity>(
  options: {
    label?: string;
    icon?: string;
    variant?: ActionVariant;
    allowedRoles?: string[];
    tooltip?: string;
  } = {}
): DetailActionStrict<T> {
  return {
    id: "log-deal",
    label: options.label ?? "Log a Deal",
    icon: options.icon ?? ACTION_ICONS.PLUS,
    variant: options.variant ?? ACTION_VARIANTS.OUTLINE,
    action: "openCreateDealModal",
    allowedRoles: options.allowedRoles ?? [...ROLE_COMBINATIONS.EMPLOYEE_AND_ADMIN],
    tooltip:
      options.tooltip ?? "Create a new deal pre-filled with this company",
  };
}

export function createEnrichCompanyAction<T extends BaseEntity>(
  options: {
    label?: string;
    icon?: string;
    variant?: ActionVariant;
    allowedRoles?: string[];
    tooltip?: string;
    bulkable?: boolean;
  } = {}
): DetailActionStrict<T> {
  return {
    id: "enrich-company",
    label: options.label ?? "Enrich",
    icon: options.icon ?? ACTION_ICONS.SPARKLES,
    variant: options.variant ?? ACTION_VARIANTS.OUTLINE,
    action: "enrichCompany",
    allowedRoles: options.allowedRoles ?? [...ROLE_COMBINATIONS.ADMIN_ONLY],
    tooltip: options.tooltip ?? "Trigger data enrichment from external service",
    bulkable: options.bulkable ?? true,
  };
}
